import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthGuard } from "./components/AuthGuard";
import { AuthProvider } from "./lib/auth";
import { ContentProvider } from "./lib/content";
import { ThemeProvider } from "./lib/theme";
import { AdminComoFunciona } from "./pages/AdminComoFunciona";
import { AdminContactos } from "./pages/AdminContactos";
import { AdminDashboard } from "./pages/AdminDashboard";
import { AdminInicio } from "./pages/AdminInicio";
import { AdminLayout } from "./pages/AdminLayout";
import { AdminLogin } from "./pages/AdminLogin";
import { AdminServicos } from "./pages/AdminServicos";
import { HomePage } from "./pages/HomePage";

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ContentProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <AuthGuard>
                    <AdminLayout />
                  </AuthGuard>
                }
              >
                <Route index element={<AdminDashboard />} />
                <Route path="inicio" element={<AdminInicio />} />
                <Route path="servicos" element={<AdminServicos />} />
                <Route path="como-funciona" element={<AdminComoFunciona />} />
                <Route path="contactos" element={<AdminContactos />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </ContentProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
